<div class="row">
  <div id="chart">
    <apx-chart #chart
      [series]="chartOptions.series!" 
      [chart]="chartOptions.chart!"
      [plotOptions]="chartOptions.plotOptions!"
      [xaxis]="chartOptions.xaxis!" 
      [yaxis]="chartOptions.yaxis!" 
      [legend]="chartOptions.legend!"></apx-chart>
  </div>
</div>